<template>
  <div>
    <div class="columns">
      <page-header title="Tiempos por zona"></page-header>
    </div>
    <filtros @change="changeFiltersHandle"></filtros>
    <section>
      <div class="dashboard-tiempos-x-zona">
        <div class="titulos">
          <div class="zona-gap"></div>
          <div class="titulo-item">Asignaci&oacute;n</div>
          <div class="titulo-item">Picking</div>
          <div class="titulo-item">Despacho</div>
          <div class="titulo-item">T&deg; Total</div>
          <div class="titulo-item">Meta</div>
          <div class="titulo-item">Bajo T&deg; Asegurado</div>
          <div class="titulo-item">Meta</div>
        </div>
        <tiempo-por-zona-item
          v-for="(item, index) in zonas"
          :key="`item-zona-${index}`"
          :item="item"
        ></tiempo-por-zona-item>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { dashboardService } from '@/services'
import Filtros from '@/components/dashboard/Filtros.vue'
import PageHeader from '@/components/shared/PageHeader.vue'
import TiempoPorZonaItem from '@/components/dashboard/TiempoPorZonaItem.vue'

export default {
  name: 'TiemposPorZona',
  components: {
    Filtros,
    PageHeader,
    TiempoPorZonaItem
  },
  data() {
    return {
      desde: null,
      hasta: null,
      zonas: [],
      timer: null
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega'])
  },
  beforeDestroy() {
    this.removeTimer()
  },
  methods: {
    changeFiltersHandle(payload) {
      this.desde = payload.desde
      this.hasta = payload.hasta
      this.removeTimer()
      this.getDashboardData().then((_) => {
        this.timer = setInterval(() => this.getDashboardData(), 60000)
      })
    },
    async getDashboardData() {
      try {
        const rs = await dashboardService.getDashboardDataset(
          1,
          this.bodega.id,
          this.desde,
          this.hasta
        )
        this.zonas = rs.data
      } catch (e) {
        this.procesarError(e)
      }
    },
    removeTimer() {
      if (this.timer !== null) clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-tiempos-x-zona {
  font-size: 1.5rem;
  font-weight: bold;
  display: block;

  .titulos {
    .zona-gap {
      margin: 10px 0;
      width: 25%;
      display: inline-block;
    }

    .titulo-item {
      color: rgba(213, 117, 45, 1);
      display: inline-block;
      text-align: center;
      width: 9.5%;
    }
  }
}
</style>
